import React from "react";

const TABS = [
  { id: "review", label: "Review", badge: true },
  { id: "hospitals", label: "Hospitals" },
  { id: "employees", label: "Employees" }
];

export default function AdminTabs({ activeTab, onChange, counts }) {
  return (
    <div className="admin-tab-nav" role="tablist" aria-label="Admin management section">
      {TABS.map((tab) => {
        const count = counts?.[tab.id];
        return (
          <button
            key={tab.id}
            id={`${tab.id}-tab`}
            type="button"
            role="tab"
            tabIndex={activeTab === tab.id ? 0 : -1}
            aria-controls={`${tab.id}-panel`}
            aria-selected={activeTab === tab.id}
            className={activeTab === tab.id ? "admin-tab active" : "admin-tab"}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
            {tab.badge && count != null && count > 0 ? (
              <span className="admin-tab-badge" aria-label={`${count} items`}>{count}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}